import styled from 'styled-components'

import color from '../../config/color'

export const Wrapper = styled.div`
  a{         
    text-decoration: none;
    color: ${color.textWhite};    
    :hover{
      color: ${color.textWhite};            
    }
    
  }
  
  nav{     
    background-color: ${color.primary};  
    div{
      
      background-color: ${color.primary};      
    }
    span{
      color: ${color.textWhite};
    }
  }
   
  
  // nav{
  //  background-color: ${color.primary};
  //   li{
  //     background-color: ${color.primary};
  //   }
  // }
`
